
import { v4 as uuidv4 } from 'uuid';
import { ReferralId, ReferralIdStatus } from './types';
import { getReferralIdBank, updateReferralIdBank, saveReferralIdBank } from './storage';

// Generate a unique 7-digit alphanumeric code
export const generateReferralCode = (): string => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let code = '';
  
  // Generate a 7-character code
  for (let i = 0; i < 7; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    code += characters[randomIndex];
  }
  
  // Check if code already exists in the bank
  const codeExists = getReferralIdBank().some(item => item.code === code);
  if (codeExists) {
    // If code already exists, generate a new one recursively
    return generateReferralCode();
  }
  
  return code;
};

// Generate a batch of new referral IDs
export const generateReferralIds = (
  instanceId: string,
  count: number = 10,
  prefix: string = 'REF'
): ReferralId[] => {
  const newIds: ReferralId[] = [];
  
  for (let i = 0; i < count; i++) {
    const randomString = Math.random().toString(36).substring(2, 8).toUpperCase();
    const code = `${prefix}${randomString}`;
    
    const newId: ReferralId = {
      id: uuidv4(),
      code: code,
      userId: '',
      instanceId: instanceId,
      status: 'unused' as ReferralIdStatus,
      createdAt: new Date(),
      updatedAt: new Date(),
      isAssigned: false
    };
    
    newIds.push(newId);
  }
  
  // Add new IDs to the bank
  const currentBank = getReferralIdBank();
  updateReferralIdBank([...currentBank, ...newIds]);
  
  return newIds;
};

// Check if bank needs replenishment (less than 500 unassigned codes)
export const checkAndReplenishBank = (): boolean => {
  const currentBank = getReferralIdBank();
  const unassignedCount = currentBank.filter(item => !item.isAssigned).length;
  
  if (unassignedCount < 500) {
    const countToGenerate = 500;
    console.log(`Replenishing referral ID bank with ${countToGenerate} new IDs`);
    generateReferralIds('default', countToGenerate);
    return true;
  }
  
  return false;
};

// Initialize the bank with 1000 IDs if it's empty
export const initializeBank = (): void => {
  const currentBank = getReferralIdBank();
  if (currentBank.length === 0) {
    console.log('Initializing referral ID bank with 1000 IDs');
    generateReferralIds('default', 1000);
  }
};

// Initialize on first import
initializeBank();
